<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Email Notification Setup</h1>
      <v-row>
        <v-col cols="12" md="4">
          <v-row>
            <v-col :class="classPadding">
              <v-text-field
                label="Regularization"
                :class="classPadding"
                v-model="config.noDaysNotifForRegularization"
                :disabled="!onEdit"
                autocomplete="off"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col :class="classPadding">
              <v-text-field
                :class="classPadding"
                v-model="config.noDaysNotifForEndContract"
                :disabled="!onEdit"
                autocomplete="off"
                label="End of Contract"
                type="number"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col :class="classPadding" cols="12">
          <v-btn
            class="mx-2"
            color="info"
            @click.stop="onEdit = true"
            :disabled="onEdit"
            >Edit</v-btn
          >
          <v-btn class="mx-2" :disabled="!onEdit" @click.stop="cancel"
            >Cancel</v-btn
          >
          <v-btn
            class="mx-2"
            color="success"
            :disabled="!onEdit"
            @click.stop="update"
            :loading="isUpdating"
            v-if="userAccess.update >= 1 || userAccess.add >= 1"
            >Update</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/config";
export default {
  metaInfo: {
    title: "Email Address Configuration",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
   mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    onEdit: false,
    config: {},
    isUpdating: false
  }),
  methods: {
    update() {
      this.isUpdating = true;
      this.$axios
        .put(`${API_ENDPOINT}/email-notif`, this.config)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.cancel();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    cancel() {
      this.onEdit = false;
      this.getEmailNotif();
    },
    getEmailNotif(){
      this.$axios.get(`${API_ENDPOINT}/email-notif`)
        .then(({ data }) => {
          this.config = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    }
  },
  created() {
    this.getEmailNotif();

    this.getUserAccessRights("EMFSENotif");
  },
}
</script>